import z from "zod";

import { MediaPostSchema } from "@features/media-card/model";

import { createComponentSchemas } from "@shared/content-types/utils";

const GridMediaListSchema = z.object({
  isVisible: z.boolean().optional().default(true),
  media_posts: z.array(MediaPostSchema),
  title: z.string().min(1),
  subtitle: z.string().min(1),
});

export const GridMediaListSection = createComponentSchemas(
  "sections.grid-media-list",
  GridMediaListSchema,
);
